module.exports = __webpack_public_path__ + "static/media/Galdisa_Ficha_crunchy_flavor.f93448da.pdf";